import React from 'react';
import './Loading.css';

const Loading = ({ size = 'medium', text, fullScreen = false }) => {
  const spinner = (
    <div className={`loading loading-${size}`}>
      <div className="loading-spinner">
        <svg viewBox="0 0 50 50">
          <circle
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke="currentColor"
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray="31.416 31.416"
          />
        </svg>
      </div>
      {text && <span className="loading-text">{text}</span>}
    </div>
  );

  if (fullScreen) {
    return <div className="loading-fullscreen">{spinner}</div>;
  }

  return spinner;
};

export default Loading;

